import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import skillsDashboardPlugin from '@internal/plugin-skills-dashboard';
import { navModule } from './modules/nav';

export default createApp({
  features: [catalogPlugin, skillsDashboardPlugin, navModule],
});
